module.exports = __webpack_public_path__ + "img/Slice120.ad5b275d.png";